module.exports = __webpack_public_path__ + "img/CCWhiteContent.ef333396.jpg";